
import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import Confirm from 'vux/src/components/confirm/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
data () {
return {
toastshow:false,
toastTxt:'',
addDialog:false,
templetName:'',
templetContent:'',
resultOption:[
{
title:'324234234',
content:'234324324234234'
},
{
title:'324234234',
content:'234324324234234'
}
],
}
},
directives: {
TransferDom
},
components: {
Confirm,Swipeout, SwipeoutItem, SwipeoutButton,CheckIcon,Search,Toast,Tab, TabItem,XDialog,Qrcode,XInput,PopupRadio,Cell,XTextarea, Group, XHeader,XButton
},
methods:{
edit(item){
this.addDialog = true;
this.templetName = item.templetName;
this.templetContent = item.templetContent;
this.id = item.id;
},//编辑
del(id,index){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyPatientNewsdel,{
"certNo": "",
"channelIdent": "",
"id": id,
"identityNo": "",
"name": "",
"page": 0,
"personInfoId": this.personInfoid,
"phone": "",
"rows": 0,
"userId": ""
}).then(response => {
this.resultOption.splice(index,1);
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.toastTxt = '删除成功';
this.toastshow = true;
}).catch(error => {

})

}, // 删除
submit(){
this.templetName = this.templetName.trim();
this.templetContent =  this.templetContent.trim();
if(this.personInfoid){
if(this.templetName && this.templetContent){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyPatientNewsSave,{
id: this.id,
personInfoId: this.personInfoid,
templetContent: this.templetContent,
templetName: this.templetName
}).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.addDialog = false;
promptMessage('提示','保存成功！');
this.getData();
}).catch(error => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示',error);
})
}else{
promptMessage('提示','短信标题和短信内容不能为空');
}
}else {
promptMessage('提示','为获取到您的信息，请关闭页面重新进入！');
}
}, //保存
dialogshowMeodth(){
this.templetName = '';
this.templetContent = '';
},
getData(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',urlConfig.pregnancyPatientgetNews,{
"id": "",
"personInfoId": this.personInfoid,
"templetContent": "",
"templetName": ""
}).then(response => {
this.resultOption = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}//获取数据
},

mounted(){
getken(this.getData);
this.personInfoid = window.localStorage.getItem('userid');
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input, textarea').focus();
});
$('input, textarea').on('blur', function () {

setTimeout(function(){
var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
window.scrollTo(0, Math.max(scrollHeight - 1, 0));
$('body').height($('body')[0].clientHeight);
}, 100);
});
})
}
}



// WEBPACK FOOTER //
// ./src/project/pregnancyProject/pregnancyPatientNews.vue